import { useRef } from 'react';
import { Paperclip, X } from 'lucide-react';

const ACCEPTED = '.pdf,.doc,.docx,.jpg,.jpeg,.png';
const MAX_MB = 5;

export default function FileInput({ file, onChange, label = "Pièce jointe" }) {
  const ref = useRef(null);

  const handleFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (f.size > MAX_MB * 1024 * 1024) {
      alert(`Le fichier dépasse ${MAX_MB} Mo.`);
      return;
    }
    onChange(f);
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1.5">{label}</label>
      {file ? (
        <div className="flex items-center gap-2 px-4 py-3 rounded-xl border border-gray-200 bg-white text-sm">
          <Paperclip size={14} className="text-gray-400 shrink-0" />
          <span className="truncate text-gray-700 flex-1">{file.name}</span>
          <button type="button" onClick={() => { onChange(null); ref.current.value = ''; }}
            className="text-gray-400 hover:text-red-500 transition-colors shrink-0">
            <X size={14} />
          </button>
        </div>
      ) : (
        <button type="button" onClick={() => ref.current.click()}
          className="w-full flex items-center gap-2 px-4 py-3 rounded-xl border border-dashed border-gray-300 bg-white text-sm text-gray-500 hover:border-gray-400 hover:text-gray-700 transition-colors">
          <Paperclip size={14} />
          <span>Ajouter un fichier (PDF, Word, image — max {MAX_MB} Mo)</span>
        </button>
      )}
      <input ref={ref} type="file" accept={ACCEPTED} className="hidden" onChange={handleFile} data-testid="file-input" />
    </div>
  );
}
